import { render, staticRenderFns } from "./AssetContext.vue?vue&type=template&id=3a41858e&scoped=true"
import script from "./AssetContext.vue?vue&type=script&lang=js"
export * from "./AssetContext.vue?vue&type=script&lang=js"
import style0 from "./AssetContext.vue?vue&type=style&index=0&id=3a41858e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a41858e",
  null
  
)

export default component.exports